<template lang="pug">
  button(type="button" @click="buttonClicked" :class="{ selected: selected, disabled: disabled } ").round-button.xs-f-small.lg-f-medium.max-at-tweak
    slot

</template>

<script>
  export default {
    name: "RoundButton",
    props: {
      selected: {
        type: Boolean,
        required: false,
        default: false
      },

      disabled: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    methods: {
      buttonClicked() {
        this.$emit('round-button-click');
      }
    }
  }
</script>

<style scoped lang="stylus">
  .round-button
    padding 0.5em 1em
    border-radius 0.5em
    margin 1.5% 0
    background-color #fff
    border 2px solid #ebebeb
    color #000
    position relative
    text-align center
    transition(color 0.2s\, border-color 0.2s)

    .text
      top 50%
      left 0
      right 0
      padding-right 0.5em
      padding-left 0.5em
      position absolute
      transform(translateY(-50%))


    &.large
      min-height 4.5em

    &:hover
    &.selected
      color color-mr-deepblue
      border 2px solid color-mr-blue

</style>